// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-table[data-v-1a07e16a] {\n  padding: 20px;\n}\n.custom-table .customer-table[data-v-1a07e16a] {\n  margin-top: 20px;\n}", ""]);
// Exports
module.exports = exports;
